import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Bank = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M4.72727 17.4587V11.0951M8.36364 17.4587V11.0951M12 17.4587V11.0951M15.6364 17.4587V11.0951M19.2727 17.4587V11.0951M2 21.0951H22M12.3364 3.04966L20.5182 6.32237C20.8364 6.44964 21.0909 6.83145 21.0909 7.16782V10.186C21.0909 10.686 20.6818 11.0951 20.1818 11.0951H3.81818C3.31818 11.0951 2.90909 10.686 2.90909 10.186V7.16782C2.90909 6.83145 3.16364 6.44964 3.48182 6.32237L11.6636 3.04966C11.8455 2.97694 12.1545 2.97694 12.3364 3.04966ZM21.0909 21.0951H2.90909V18.3678C2.90909 17.8678 3.31818 17.4587 3.81818 17.4587H20.1818C20.6818 17.4587 21.0909 17.8678 21.0909 18.3678V21.0951ZM13.3636 7.45873C13.3636 8.21184 12.7531 8.82237 12 8.82237C11.2469 8.82237 10.6364 8.21184 10.6364 7.45873C10.6364 6.70561 11.2469 6.09509 12 6.09509C12.7531 6.09509 13.3636 6.70561 13.3636 7.45873Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeMiterlimit: "10",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
